<template>
	<div class="app-main">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>地址信息</span>
		</div>
		<div style="padding-bottom: 5px;">
			<el-alert description="提示: 您的企业可能在多地有工厂/分公司，建议维护完整信息，展示贵司规模。">
			</el-alert>
		</div>
		<el-row class="mg-b5">
			<el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle">
				<el-table-column prop="country" label="国家地区" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="place" label="省/市/区" :show-overflow-tooltip="true"> </el-table-column>
				<el-table-column prop="address" label="详细地址" :show-overflow-tooltip="true"> </el-table-column>
				<el-table-column prop="yzCode" label="邮政编码" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"> </el-table-column>
				<el-table-column label="操作" width="100" align="center" fixed="right">
					<template slot="header" slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleAdd">新增
						</el-button>
					</template>
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="handleEdit(scope.row)">修改
						</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.row.rowId)">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<div v-if="!preview" style="text-align: center;">
			<span slot="footer" class="dialog-footer">
				<el-button @click="backStep" size="small">上一步</el-button>
				<el-button type="primary" @click="nextStep" size="small">下一步</el-button>
			</span>
		</div>
		<el-dialog :visible.sync="openDialog" width="600px" :title="title" :close-on-click-modal="false">
			<el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
				<el-row>
					<el-col :span="24">
						<el-form-item label="国家地区" prop="country">
							<el-select v-model="form.country" placeholder="请选择" style="width: 100%;" filterable>
								<el-option v-for="item in countrys" :key="item.name" :label="item.name"
									:value="item.name">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="省/市/区" prop="place">
							<el-input v-model="form.place" placeholder="请输入省/市/区" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="详细地址" prop="address">
							<el-input v-model="form.address" placeholder="请输入详细地址" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="邮政编码" prop="yzCode">
							<el-input v-model="form.yzCode" placeholder="请输入邮政编码" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注" prop="remark">
							<el-input v-model="form.remark" placeholder="请输入备注" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="openDialog = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitForm" size="small">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		supplierAddressList,
		addSupplierAddress,
		editSupplierAddress,
		delSupplierAddress,
	} from '@/api/gys/supplierAddress.js'
	import constant from '@/api/commons.js'
	import{addSupplierApprovalMx, getSupplierApprovalMx} from '@/api/gys/supplierInfo.js'
	import { createHash } from '@/utils/index'
	export default {
		name: "Address",
		computed: {},
		props: {
			basicId: {
				type: Number,
			},
			preview: {
				type: Boolean,
				default: false
			},
			otherInfo: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				title: "",
				tableData: [],
				countrys: constant.country,
				form: {},
				loadingInstance: undefined,
				openDialog: false,
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						hId: this.basicId,
					}
				},
				rules: {
					country: [{
						required: true,
						message: '请输入国家地区',
						trigger: 'blur'
					}],
					place: [{
						required: true,
						message: '请输入省/市/区',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入详细地址',
						trigger: 'blur'
					}],
				}
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			async getList() {
				let _this = this;
				let pramar = {
					classType:'com.srm.entity.SupplierAddress',
					classTypeIndex:'0',
					supplierInfoId:_this.basicId,
				};
				if(this.otherInfo.lastPass){
					pramar['queryType']='lastPass'
				}
				getSupplierApprovalMx(pramar).then(({data:res}) => {
					console.log(res)
					this.tableData = [];
					if(res.data && res.data.jsonData){
						this.tableData = JSON.parse(res.data.jsonData)
					}
				})
			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					createTime: undefined,
					createUser: this.$store.getters['user/user'].id,
					country: undefined,
					place: undefined,
					address: undefined,
					yzCode: undefined,
					remark: undefined,
					hId: this.basicId,
				}
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						let oldData = JSON.parse(JSON.stringify(_this.tableData))
						let data = JSON.parse(JSON.stringify(_this.form));
						if (data.rowId != undefined) {
							let num = -1;
							oldData.forEach((nItem,index)=>{
								if(nItem.rowId == data.rowId){
									num = index;
								}
							})
							if(num>=0){
								oldData[num] = data;
							}
							_this.addFun(oldData);
						} else {
							data.rowId = createHash();
							oldData.push(data)
							_this.addFun(oldData);
						}
					}
				});
			},
			addFun(data){
				let _this = this;
				addSupplierApprovalMx({
					classType:'com.srm.entity.SupplierAddress',
					classTypeIndex:'0',
					supplierInfoId:this.basicId,
					jsonData:JSON.stringify(data)
				}).then((res)=>{
					_this.$success('添加成功');
					_this.openDialog = false;
					_this.getList();
				})
			},
			handleAdd: function() {
				this.reset();
				this.title = "新增";
				this.openDialog = true;
			},
			handleEdit: function(row) {
				this.reset();
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				this.openDialog = true;
			},
			//上一步
			backStep: function() {
				this.bus.$emit('stepsFun', 3);
			},
			//下一步
			nextStep: function() {
				if (this.tableData.length <= 0) {
					this.$notify({
						message: '至少输入一条地址信息',
						type: 'error'
					});
					return false;
				}
				this.bus.$emit('stepsFun', 5);
			},


			handleDel: function(id) {
				let _this = this;
				let oldData = JSON.parse(JSON.stringify(_this.tableData))
				let newData = [];
				oldData.forEach((item)=>{
					if(item.rowId != id){
						newData.push(item)
					}
				})
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						_this.addFun(param);
					},
					data: newData //参数对象 主要回调函数用
				});
			},

		}
	};
</script>
<style scoped="scoped">
</style>
